.insightsIconContainer {
  display: flex;
  position: relative;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;

  &:hover {
    transform: scale(1.25);
  }

  &:disabled {
    pointer-events: none;
  }
}

.scenarioIconWrapper {
  display: inline-flex;
  cursor: pointer;
}
